import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';

// 定义状态类型
interface State {
  apkUrl: string;
  exeUrl: string;
}

// 定义初始状态
const initList: State = {
  apkUrl: '',
  exeUrl: ''
};

// 创建一个 slice
const exampleSlice = createSlice({
  name: 'list',
  initialState: initList,
  reducers: {
    setList(state, action) {
      state.apkUrl = action.payload.apkUrl
      state.exeUrl = action.payload.exeUrl
    }
  }
});

// 导出 actions
export const { setList } = exampleSlice.actions;

// 创建 Redux store
const store = configureStore({
  reducer: exampleSlice.reducer,
});
export type RootState = ReturnType<typeof store.getState>;
// 导出 store
export default store;